import Vue from 'vue'
import Router from 'vue-router'
// The homepage ships in the main bundle; every other route loads on demand.
import Homepage from '@/components/Homepage'
const Transactions = () => import(/* webpackChunkName: "lists" */ '@/components/Transactions');
const Leaderboard = () => import(/* webpackChunkName: "lists" */ '@/components/Leaderboard');
const Break = () => import(/* webpackChunkName: "games" */ '@/components/Break');
const Drop = () => import(/* webpackChunkName: "games" */ '@/components/Drop');
const Circles = () => import(/* webpackChunkName: "games" */ '@/components/Circles');
const About = () => import(/* webpackChunkName: "pages" */ '@/components/About');
const Menu = () => import(/* webpackChunkName: "pages" */ '@/components/Menu');
const Plots = () => import(/* webpackChunkName: "plots" */ '@/components/Plots');
const Spaces = () => import(/* webpackChunkName: "pages" */ '@/components/Spaces');
const Demo = () => import(/* webpackChunkName: "pages" */ '@/components/Demo');
const Terms = () => import(/* webpackChunkName: "pages" */ '@/components/Terms');
const Privacy = () => import(/* webpackChunkName: "pages" */ '@/components/Privacy');
const Subscribe = () => import(/* webpackChunkName: "pages" */ '@/components/Subscribe');
const Tang = () => import(/* webpackChunkName: "subpages" */ '@/components/Tang');
const Dob = () => import(/* webpackChunkName: "subpages" */ '@/components/Dob');
const Preme = () => import(/* webpackChunkName: "subpages" */ '@/components/Preme');
const Zora = () => import(/* webpackChunkName: "subpages" */ '@/components/Zora');
const Plot = () => import(/* webpackChunkName: "lists" */ '@/components/Plot');
const Agents = () => import(/* webpackChunkName: "pages" */ '@/components/Agents');

Vue.use(Router);

const router = new Router({
  mode: 'history', // routes without the hash
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage,
      meta: {
        title: 'Million Bit Homepage'
      }
    },
    {
      path: '/list',
      name: 'list',
      component: Transactions,
      meta: {
        title: 'Million Bit List'
      }
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: Leaderboard,
      meta: {
        title: 'Million Bit Leaderboard'
      }
    },
    {
      path: '/break',
      name: 'break',
      component: Break,
      meta: {
        title: 'Million Bit Break'
      }
    },
    {
      path: '/drop',
      name: 'drop',
      component: Drop,
      meta: {
        title: 'Million Bit Drop'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: 'About the Million Bit Homepage'
      }
    },
    {
      path: '/menu',
      name: 'nav-menu',
      component: Menu,
      meta: {
        title: 'Million Bit Menu'
      }
    },
    {
      path: '/demo',
      name: 'nav-demo',
      component: Demo,
      meta: {
        title: 'Million Bit Homepage Demo'
      }
    },
    {
      path: '/plots',
      name: 'plots',
      component: Plots,
      meta: {
        title: 'Million Bit Homepage Plots'
      }
    },
    {
      path: '/spaces',
      name: 'spaces',
      component: Spaces,
      meta: {
        title: 'Based Spaces',
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        title: 'Million Bit Homepage - Terms of Service',
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        title: 'Million Bit Homepage - Privacy Policy',
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: Subscribe,
      meta: {
        title: 'Subscribe to the Million Bit Homepage',
      }
    },
    {
      path: '/tang',
      name: 'tang',
      component: Tang,
      meta: {
        title: 'Tang Tree powered by the Million Bit Homepage',
      }
    },
    {
      path: '/dob',
      name: 'dob',
      component: Dob,
      meta: {
        title: 'DOB Pixel Gallery powered by the Million Bit Homepage',
      }
    },
    {
      path: '/preme',
      name: 'preme',
      component: Preme,
      meta: {
        title: 'Preme Bit Page powered by the Million Bit Homepage',
      }
    },
    {
      path: '/zora',
      name: 'zora',
      component: Zora,
      meta: {
        title: 'Million Zora Post powered by the Million Bit Homepage',
      }
    },
    {
      path: '/circles',
      name: 'circles',
      component: Circles,
      meta: {
        title: 'Million Circles',
      }
    },
    {
      path: '/plot/:id',
      name: 'plot',
      component: Plot,
      meta: {
        title: 'Plot Details - Million Bit Homepage'
      }
    },
    {
      path: '/agents',
      name: 'agents',
      component: Agents,
      meta: {
        title: 'Agents - Million Bit Homepage',
      }
    },
    {
      path: '*', // Catch-all for undefined paths in the new mode
      redirect: '/', // Redirect to home or any other default route
    },
  ]
});

// The games size their canvases from a 1024px-wide page, as phones rendered
// the whole site before it had a mobile layout; keep that for them only.
const GAME_VIEWPORT = 'width=1024';
const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1';
const GAME_PATHS = ['/break', '/drop', '/circles'];
router.beforeEach((to, from, next) => {
  const isGame = GAME_PATHS.includes(to.path);
  const meta = document.querySelector('meta[name=viewport]');
  if (meta) {
    meta.setAttribute('content', isGame ? GAME_VIEWPORT : DEFAULT_VIEWPORT);
  }
  document.documentElement.classList.toggle('game-viewport', isGame);
  next();
});

router.beforeEach((to, from, next) => {
  // Access the title from the route's meta field
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'Million Bit Homepage'; // Fallback title
  }
  next(); // Proceed to the route
});

export default router;
